import { render, staticRenderFns } from "./WelcomeVideoModal.vue?vue&type=template&id=7d45a6d3&scoped=true&"
import script from "./WelcomeVideoModal.vue?vue&type=script&lang=js&"
export * from "./WelcomeVideoModal.vue?vue&type=script&lang=js&"
import style0 from "./WelcomeVideoModal.vue?vue&type=style&index=0&id=7d45a6d3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d45a6d3",
  null
  
)

export default component.exports